import {t} from "@lingui/core/macro";
import * as React from "react";

import {PushUtils} from "@atg-tillsammans/push-data-access";
import ChatAvatar from "@atg-tillsammans/team-chat-feature/components/TeamChatAvatar";
import {Paths} from "@atg-tillsammans-shared/navigation";
import {GameUtils} from "@atg-tillsammans-shared/utils";
import browserHistory from "atg-history";
import {Typography} from "atg-ui-components";

import * as styles from "./RoundActivatedNotification.styles";

import type {Round} from "@atg-tillsammans/types/generated";

export type Props = {
    round: Round;
    teamName: string;
    numberOfShares: number;
};

function RoundActivatedNotification({round, teamName, numberOfShares}: Props) {
    const {gameInitiator} = round;
    return (
        <div
            data-test-id="notification-activatedround-root"
            css={styles.container}
            onClick={() =>
                browserHistory.push(Paths.getTeamGamePagePath(round.teamId, round.gameId))
            }
        >
            <div css={styles.aside}>
                {gameInitiator && (
                    <ChatAvatar
                        imageUrl={gameInitiator.imageUrl ?? null}
                        alt={`${gameInitiator.firstName} ${gameInitiator.lastName}`}
                        online
                        showTooltip
                    />
                )}
            </div>
            <div css={styles.main}>
                {gameInitiator && (
                    <Typography
                        data-test-id="notification-activatedround-title"
                        variant="headline3"
                        component="span"
                        color="inherit"
                        style={styles.title}
                        data-di-mask="true"
                        data-hj-masked="true"
                    >
                        {t({
                            id: "push.notification.activatedround.title",
                            message: `${PushUtils.capitalized(
                                `${gameInitiator.firstName} ${gameInitiator.lastName}`,
                            )} har öppnat ${GameUtils.getWeekDay(round.gameId)}ens ${GameUtils.parseGameType(
                                round.gameId,
                            )} i ${teamName}! ${
                                numberOfShares > 0
                                    ? `Du deltar med ${numberOfShares} andel${
                                          numberOfShares > 1 ? "ar" : ""
                                      }.`
                                    : ""
                            }`,
                        })}
                    </Typography>
                )}
            </div>
        </div>
    );
}

export default RoundActivatedNotification;
